/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {GanttSection} from './GanttSection';

export class GanttChart {

    public showSectionBackgrounds = true;
    public showGanttItems = true;
    public showSpecialDates = true;
    public showSpecialDateLines = true;
    public showSpecialDateValue = false;

    constructor(public title: string, public ganttSections: GanttSection[]) {
    }

    public getDateSpan(): {startDate: Date, endDate: Date} {
        const range = {startDate: null, endDate: null};
        for (const ganttSection of this.ganttSections) {
            for (const ganttItem of ganttSection.ganttItems) {
                const startDate = ganttItem.getDateStart();
                const endDate = ganttItem.getDateEnd();
                if (!range.startDate || startDate < range.startDate) {
                    range.startDate = startDate;
                }
                if (!range.endDate || endDate > range.endDate) {
                    range.endDate = endDate;
                }
            }
        }
        // If no gantt items were found, return default dates (today +/- 1 month)
        if (!range.startDate || !range.endDate) {
            const today = new Date();
            range.startDate = new Date(today.getTime() - 1000 * 60 * 60 * 24 * 30); // one month ago
            range.endDate = new Date(today.getTime() + 1000 * 60 * 60 * 24 * 30); // one month from now
            return range;
        }
        // Add a little padding to the left and right side of the chart, so if a special date is printed,
        // its not clipped by the edges of the chart:
        range.startDate = new Date(range.startDate.getTime() - 1000 * 60 * 60 * 24 * 7 * 2); // subtract two weeks
        range.endDate = new Date(range.endDate.getTime() + 1000 * 60 * 60 * 24 * 7 * 2); // add two weeks
        return range;
    }
}
